<template>
    <modal size="lg" :height-max="true" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" id="editReimbursementPositionsModal" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit {{ this.step == 'default' ? 'Default Positions' : 'Positions' }}</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div v-if="reimbursement.company"><span class="text-muted">Company: </span>{{ reimbursement.company.name }}</div>
                    <div><span class="text-muted">Reimbursement: </span>{{ reimbursement.name || reimbursement.reimbursement_type.name }}</div>
                </div>
            </div>

            <div v-if="step == 'available'">
                <form-errors :errors="formErrors"/>

                <p class="mb-2">Select the positions that can use this reimbursement.</p>

                <position-selector v-if="positionsLoaded" :all-positions="allCompanyPositions" :companies="client.companies" v-model="formData.positions"/>
            </div>

            <div v-if="step == 'default'">
                <form-errors :errors="formErrors"/>

                <p class="mb-2">Select the positions that will use this reimbursement by default.</p>

                <position-selector v-if="positionsLoaded" :all-positions="selectedAvailablePositions" :companies="client.companies" v-model="formData.default_positions" :allPositionsLabel="'Available Positions'"/>
            </div>
        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button v-if="step == 'available'" type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button v-else-if="step == 'default'" type="button" class="btn btn-outline-primary" @click.prevent="step = 'available'">
                    Back
                </button>
                <button v-if="step == 'available'" type="button" class="btn btn-primary" @click.prevent="step = 'default'">
                    Continue
                </button>
                <button v-else-if="step == 'default'" type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PositionSelector from '@/pages/client/Settings/components/PositionSelector'

export default {
    props: ['client', 'reimbursement'],
    mixins: [FormMixin, ModalMixin],
    components: {PositionSelector, },
    data() {
        return {
            step: 'available',
            formData: this.makeFormData(),
            allPositions: [],
            positionsLoaded: false,
        }
    },
    watch: {
        reimbursement() {
            this.reset()
            this.step = 'available'
        }
    },
    mounted() {
        this.getPositions()
    },
    computed: {
        allCompanyPositions() {
            return this.allPositions.filter(p => p.company_id == this.reimbursement.company_id)
        },
        selectedAvailablePositions() {
            return this.allCompanyPositions.filter(p => this.formData.positions.includes(p.id))
        }
    },
    methods: {
        getPositions() {
            this.$api.get(`/clients/${this.client.id}/positions`).then(resp => {
                this.allPositions = resp
                this.allPositions.sort((a, b) => {return a.terminal_value.toLowerCase() > b.terminal_value.toLowerCase() ? 1 : -1})
                this.positionsLoaded = true
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            })
        },
        makeFormData() {
            const data = {
                positions: [],
                default_positions: [],
            }
            this.reimbursement.position_rels.forEach(rel => {
                data.positions.push(rel.position.id)
                if (rel.is_default) {
                    data.default_positions.push(rel.position.id)
                }
            })
            return data
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.put(`/clients/${this.client.id}/settings/reimbursement-types/${this.reimbursement.id}/positions`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        }
    }
}
</script>
